import React, { FC } from 'react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Link,
  Stack,
} from '@chakra-ui/react'

import { BasicComponentProps } from '../../common/types'

type AlertProps = {
  title: string
  content: string
  url?: string
}

const AlertInfo: FC<BasicComponentProps<AlertProps>> = ({
  title,
  content,
  url,
  ...rest
}) => {
  return (
    <Alert
      status='info'
      variant='left-accent'
      w='422px'
      pb={6}
      borderRadius='6px'
      {...rest}
    >
      <AlertIcon />
      <Stack spacing={0} w='90%'>
        <AlertTitle fontWeight='extrabold'>{title}</AlertTitle>
        <AlertDescription fontSize='sm' fontWeight={400}>
          {content}
          <Link
            fontWeight='bold'
            color='rgba(255, 255, 255, 0.64);'
            href={url}
            referrerPolicy='no-referrer'
            target='_blank'
          >
            Click Aquí
          </Link>
        </AlertDescription>
      </Stack>
    </Alert>
  )
}

export default AlertInfo
